import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./Context";
import { ToastContainer } from "react-toastify";
import "react-toastify/ReactToastify.css";
import { LoginProvider } from "./Context/Auth";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  
  // <AuthProvider>
  <>
      <App />
      <ToastContainer />
      </>
    // </AuthProvider>
);

reportWebVitals();
